import React from "react"
import { Link } from "react-router-dom"

function Nav(props) {
	return (
		<nav>
			<div className="nav-l" style={props.styles}>
				<Link className="nav-link">Work</Link>
				<Link className="nav-link">Studio</Link>
				<Link className="nav-link">Play</Link>
				<div className="nav-line"></div>
			</div>
			<div className="nav-r"></div>
		</nav>
	)
}

export default Nav
